<form class="createForm drop-padding" (ngSubmit)="create()" [formGroup]="createForm">
  <mat-form-field appearance="outline">
    <mat-label>Название</mat-label>
    <input matInput placeholder="Название" formControlName="description" />
  </mat-form-field>
  <button mat-flat-button color="primary">Сохарнить</button>
</form>
